import clsx from 'clsx';

function GetInputClassName(_ref) {
  let {
    basicClassName,
    horizontal,
    invalidState,
    className
  } = _ref;
  return clsx(basicClassName, className, horizontal ? 'flex flex-grow-1' : null, invalidState ? 'p-invalid' : null);
}

export { GetInputClassName };
